import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center px-6">
        <div className="w-8 h-8 border-4 border-sky-500 border-t-transparent rounded-full animate-spin" />
        <p className="mt-6 text-center text-sm text-slate-400 max-w-xs leading-relaxed">
          Przygotowujemy PromptOrigin dla Ciebie. Ze względu na złożoność platformy ładowanie może potrwać chwilę.
        </p>
      </div>
    );
  }
  
  if (!user) return <Navigate to="/auth" replace />;
  if (adminOnly && !user.is_admin) return <Navigate to="/" replace />;
  
  return children;
};
